import { render } from "./NConfidence.vue?vue&type=template&id=f0651458&ts=true"
import script from "./NConfidence.vue?vue&type=script&lang=ts"
export * from "./NConfidence.vue?vue&type=script&lang=ts"

import "./NConfidence.vue?vue&type=style&index=0&id=f0651458&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__